
import React, { useEffect, useRef } from "react";
import { IconButton, Button, TextField } from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { GetCart, Increment, Decrement, Remove, GetCount, GetTotal, ClearCart, quantityHandler } from './CartHandler.js'
import { decompressToBase64, formatter } from "../../utils/common.js";
import "./Cart.css"
import CheckoutModal from './CheckoutModal.js'
import axios from "axios";

const apiUrl = process.env.REACT_APP_BASEURL;


const Cart = (props) => {
    const [isOpen, setIsOpen] = useState(false);
    const [productCount, setProductCount] = useState(GetCount);
    const [totalPrice, setTotalPrice] = useState(0);
    const [itemsCount, setItemsCount] = useState(0);
    const navigate = useNavigate();
    const [taxes, setTaxes] = useState(0);
    const [orderTotal, setOrdersTotal] = useState(0);
    const [totalCount, setTotalCount] = useState(GetTotal());
    const [shipping, setShipping] = useState(0);
    const [quoteData, setQuoteData] = useState([]);
    const [cart, setCart] = useState(GetCart());
    const [itemQty, setItemQty] = useState();
    const [inputQty, setInputQty] = useState();

    const headers = {
        "Accept": "application/json",
        "Content-Type": "application/json",
        'Authorization': 'Bearer ' + props.token.token
    };

    useEffect(() => {
        setProductCount(GetCount());
    }, []);

    function handleIncrementClick(item) {
        const updatedCart = Increment(item.ItemNumber, cart);
        setCart([...updatedCart]);
    }

    function handleDecrementClick(item) {
        const updatedCart = Decrement(item.ItemNumber, cart);
        setCart([...updatedCart]);
    }

    function handleQuantityClick(item, event) {
        const qty = parseInt(event.target.value, 10) || 1; // Ensures a valid number
        setItemQty(qty);
        const updatedCart = quantityHandler(item.ItemNumber, cart, qty);
        setCart([...updatedCart]);
    }
    

    function handleRemoveClick(item) {
        Remove(item.ItemNumber, cart);
        setCart(GetCart);
        props.setCartCount(GetCount())
        // window.location.href = '/myCart'; // Navigates and refreshes the page

    }


    function onRequestClose() {
        setIsOpen(false);
        setCart(GetCart);
        navigate('/myCart');
    }

    function handleClick() {
        setIsOpen(true)
    }

    const continueShopping = () => {
        window.location.href = '/CategorySearchResults'; // Navigates and refreshes the page

    }




    // const [purchaseClicked, setPurchaseClicked] = useState(false);
    // const [orderType, setOrderType] = useState(1);
    // const [orderNumber, setOrderNumber] = useState("");
    // const [cart, setCart] = useState(GetCart());
    // const [requirePO, setRequirePO] = useState(false);
    // const [clientOrder, setClientOrder] = useState(false);
    // const [quoteClicked, setQuoteClicked] = useState(false);
    // const [quoteNum, setQuoteNum] = useState('');


    // useEffect(() => {
    //     // console.log(`YOO this the order type: ${orderType}`);
    //     axios
    //         .get(apiUrl + `/api/Orders/GetOrderNumber?orderType=${orderType}`, {
    //             headers: {
    //                 "Accept": "application/json",
    //                 "Content-Type": "application/json",
    //                 'Authorization': 'Bearer ' + props.token.token
    //             },
    //         })
    //         .then((response) => {
    //             //  console.log("PaymentBlock getOrderNumber Data:  ", response.data);
    //             setOrderNumber(response.data); //this could be quote number or invoice number depending on the orderType

    //         })
    //         .catch((error) => {
    //             console.log(error);
    //         });


    // }, [orderType])

    // const getRequirePO2 = () => {
    //     try {
    //         axios.get(apiUrl + `/api/Users/GetPoRequired?type=2`, {
    //             headers: {
    //                 "Accept": "application/json",
    //                 "Content-Type": "application/json",
    //                 'Authorization': 'Bearer ' + props.token.token
    //             },
    //         })
    //             .then((response) => {
    //                 // console.log("PaymentBlock getRequiredPO2 Data:", response.data);
    //                 setRequirePO(response.data);

    //             })
    //             .catch((error) => {
    //                 console.log(error);
    //             });
    //     } catch (error) {
    //         console.log(error);
    //     }
    // };


    // const mounted = useRef()

    // const options = {
    //     labels: {
    //         confirmable: "OK",
    //         cancellable: ""
    //     }
    // }

    // useEffect(() => {
    //     if (quoteClicked) {
    //         setOrderType(1)
    //     }
    // })


    // function quoteClick() {
    //     setQuoteClicked(true);
    //     setOrderType(1);
    //     setTimeout(setPurchaseClicked(true), 999);
    //     setTimeout(quoteClickMethod(), 1000);
    //     window.location.href = '/myCart'; // Navigates and refreshes the page

    // };



    // function OrderSavedClear() {
    //     ClearCart();
    //     props.setCartCount(GetCount());
    //     if (orderType === 2) {
    //         alert("Your order has been submitted with terms applied");
    //     } else {
    //         alert("Your quote has been submitted, you can download it from your portal.");
    //     }
    // };




    // const quoteClickMethod = () => {
    //     if (requirePO === true && props.customerPO === null) {
    //         alert("A PO Number is required. Please Enter a PO Number.");
    //     } else {
    //         if (props.customerPO !== null) {

    //             submitOrderPO();
    //             OrderSavedClear();

    //         } else {

    //             submitOrderNoPO();
    //             OrderSavedClear();
    //         }
    //     }
    // }



    // const submitOrderPO = () => {

    //     // console.log("You are here in PaymentBlock.submitOrderPo sending : ",cart);
    //     try {
    //         axios.post(apiUrl + `/api/Orders/AddInvoice?orderNumber=${orderNumber}&orderType=${orderType}&poNumber=${props.customerPO}&freight=${props.shipping}`, cart, {
    //             headers: headers
    //         })
    //             .then((response) => {
    //                 // console.log("PaymentBlock submitOrderPO Data:", response.data);

    //             })
    //             .catch(function (error) {
    //                 if (error.response) {
    //                     console.log(error.response.data);
    //                     console.log(error.response.status);
    //                     console.log(error.response.headers);
    //                 } else if (error.request) {
    //                     // console.log("The request was made but no response was received");
    //                     // console.log("`error.request` is an instance of XMLHttpRequest in the browser and an instance of");
    //                     // console.log("http.ClientRequest in node.js");    
    //                     console.log(error.request);
    //                 } else {
    //                     console.log("Something happened in setting up the request that triggered an Error");
    //                     console.log('Error', error.message);
    //                 }
    //             });
    //     } catch (error) {
    //         console.log(error);
    //     }
    // };

    // const submitOrderNoPO = () => {
    //     try {
    //         axios.post(apiUrl + `/api/Orders/AddInvoice?orderNumber=${orderNumber}&orderType=${orderType}&freight=${props.shipping}`, cart, {
    //             headers: headers
    //         })
    //             .then((response) => {
    //                 console.log("PaymentBlock submitOrderNoPO Data:", response.data);
    //                 setQuoteNum(response.data);
    //             })
    //             .catch(function (error) {
    //                 if (error.response) {
    //                     console.log(error.response.data);
    //                     console.log(error.response.status);
    //                     console.log(error.response.headers);
    //                 } else if (error.request) {
    //                     // console.log("The request was made but no response was received");
    //                     // console.log("`error.request` is an instance of XMLHttpRequest in the browser and an instance of");
    //                     // console.log("http.ClientRequest in node.js");    
    //                     console.log(error.request);
    //                 } else {
    //                     console.log("Something happened in setting up the request that triggered an Error");
    //                     console.log('Error', error.message);
    //                 }
    //             });
    //     } catch (error) {
    //         console.log(error);
    //     }
    // };

    // console.log(quoteNum)

    // const [total, setTotal] = useState();
    // const [transaction, setTransaction] = useState("");


    // const [year, setYear] = useState((new Date()).getFullYear());
    // const [years, setYears] = useState(Array.from(new Array(10), (val, index) => index + year));


    // useEffect(() => {
    //     getRequirePO2();
    //     setTotal(props.orderTotal);
    //     // console.log("PaymentBlock.UseEffect Cart: ",cart);
    // }, []);


    useEffect(() => {
        GetAllQuotes()
    }, [])
    const GetAllQuotes = () => {
        axios.get(apiUrl + "/api/Orders/GetAllQuotes", {
            headers: headers
        })
            .then((response) => {
                const data = response.data;

                setQuoteData(data); // Make sure response.data is an array
            })
            .catch((error) => {
                console.log(error);
            });
    };

    // const orderObject = quoteData.find(obj => obj.sopnumbe === quoteNum);
    // console.log(quoteData);

    //BELOW Was a post method in the original project. I changed the post top get both this call and on the API.
   

    //below was a PUT in the original code. I changed this method to get in both the code and the API
    const getCartTax = () => {
        try {
            axios.put(apiUrl + `/api/Items/GetCartTax`, JSON.stringify(GetCart()), {
                headers: headers
                // body: JSON.stringify(GetCart())
            })
                .then((response) => {
                    // console.log("TotalsBlock GetCartTaxes Data: ", response.data);

                    setTaxes(response.data);

                })
                .catch((error) => {
                    console.log(error);
                });
        } catch (error) {
            console.log(error);
        }
    }

    const getShippingTotal = () => {
        try {
            axios.put(apiUrl + `/api/ShippingRate/GetUpsGroundRate`, JSON.stringify(GetCart()), {
                headers: headers

            })
                .then((response) => {
                    // console.log("UPS GROUND RATE TOTALS BLOCK: ", response.data);
                    setShipping(response.data);

                })
                .catch((error) => {
                    console.log(error);
                });
        } catch (error) {
            console.log(error);
        }
    }
    console.log(`cart data: ${JSON.stringify(GetCart(), null, 2)}`);
    const setOrderTotal = () => {
        setOrdersTotal(productCount + props.shipping + taxes);
    }

    useEffect(() => {
        if(GetCart().length <= 0) {
            setShipping(0);
        }
    },[GetCart()])

    
    useEffect(() => {
        // console.log("Token on Totals Block",props.token);
        getShippingTotal();
        getCartTax();
        setOrderTotal();
    }, [GetCart()]);

    


    useEffect(() => {
        let itemCount = 0; // Initialize itemCount to 0
        let itemQuantity = 0;
        const total = cart.reduce((acc, item) => {
            let itemTotalCount = 0;
            itemQuantity = item.Quantity;

            if (item.Quantity && productCount) {
                itemTotalCount = productCount + item.Quantity;
            } else if (item.Quantity) {
                itemTotalCount = item.Quantity;
            }

            // Accumulate the total item count
            itemCount += itemTotalCount;
            itemCount = itemCount - productCount;

            //   console.log(`Quantity: ${item.Quantity}`);
            //   console.log(`Price: ${parseFloat(item.Price)}`);

            // Return accumulated total price
            return acc + parseFloat(item.Price) * item.Quantity;
        }, 0);

        // Set the total item count and price in state
        setItemsCount(itemCount);
        setTotalPrice(total);
        setItemQty(itemQuantity)

    }, [cart, productCount]);
    




    return (
        <div className="container " id="cart-container">

            {<div className="lg:grid grid-cols-3 lg:px-16 relative ">
                <div className="lg:col-span-2 lg:px-3 bg-white">
                    <div className=" space-y-3 ">
                        {cart.map((item) => (
                            <div className="p-3 mt-5 shadow-lg border rounded-md">
                                <div className="flex items-center" key={item.ItemNumber}>
                                    <div className="w-[15rem] h-[5rem] lg:w-[12rem] lg:h-[9rem] ">
                                        {item.Images && item.Images[0] && item.Images[0].compressedImageData ? (
                                            <img
                                                className="w-full h-full object-top"
                                                src={"data:image/png;base64," + decompressToBase64(item.Images[0].compressedImageData)}
                                                alt="image"
                                            />
                                        ) : null}

                                    </div>
                                    <div className="ml-5 space-y-1">
                                        <p className="font-semibold">{item.ItemDescription}</p>
                                        <p className="opacity-70">Item #: {item.ItemNumber}</p>

                                        <div className="flex space-x-2 items-center pt-3">
                                            <p className="opacity-50 line-through">{formatter.format(item.Price)}</p>
                                            <p className="font-semibold text-lg">
                                                {formatter.format(item.Price * 0.9)}
                                            </p>
                                            <p className="text-green-600 font-semibold">
                                                {"10"}% off
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="lg:flex items-center lg:space-x-10 pt-2">
                                    <div className="flex items-center space-x-2 ">
                                        <IconButton onClick={() => handleDecrementClick(item)} disabled={item?.Quantity <= 1} color="primary" aria-label="add an alarm">
                                            <RemoveCircleOutlineIcon />
                                        </IconButton>
                                        <input
                                            className="border rounded-sm w-16 text-center"
                                            type="number"
                                            value={item.Quantity}
                                            onChange={(e) => handleQuantityClick(item, e)}
                                        />
                                        <IconButton onClick={() => handleIncrementClick(item)} color="primary" aria-label="add an alarm">
                                            <AddCircleOutlineIcon />
                                        </IconButton>
                                    </div>
                                    <div className="flex text-sm lg:text-base mt-2 lg:mt-0 lg:pl-3">

                                        <Button onClick={() => handleRemoveClick(item)} variant="text">
                                            Remove{" "}
                                        </Button>

                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                <div className=" sticky top-0 h-[100vh] mt-5 lg:mt-0 ">
                    <div className="border p-5 bg-white shadow-lg rounded-md  details-con checkout-box">

                        <p className="font-bold opacity-60 pb-4">Order Summary</p>
                        <hr />

                        <div className="space-y-3 font-semibold">
                            <div className="flex justify-between pt-3 text-black">
                                <span>Subtotal ({itemsCount} {itemsCount > 1 ? "items" : "item"})</span>
                                <span>{formatter.format(totalPrice)}</span>
                            </div>
                            <div className="flex justify-between">
                                <span>Discount</span>
                                <span className="text-green-700">${"0"}</span>
                            </div>
                            <div className="flex justify-between">
                                <span>Shipping</span>
                                <span className="text-green-700">${shipping}</span>
                            </div>
                            <div className="flex justify-between">
                                <span>Taxes</span>
                                <span className="text-green-700">{formatter.format(taxes)}</span>
                            </div>
                            <hr />
                            <div className="flex justify-between font-bold text-lg">
                                <span>Total</span>
                                <span className="text-green-700">{formatter.format(totalPrice + shipping + taxes)}</span>
                            </div>
                        </div>

                        <Button
                            className="checkout-btn"
                            onClick={() => handleClick()}
                            variant="contained"
                            type="submit"
                            sx={{ padding: ".8rem 1rem", marginTop: "2rem", width: "8rem" }}
                            disabled={itemsCount === 0}
                        >
                            Check Out
                        </Button>
                        <Button
                            className="continue-sh"
                            onClick={continueShopping}
                            variant="contained"
                            sx={{ padding: ".8rem 1rem", marginTop: "2rem", width: "13rem", marginLeft: "1rem" }}
                        >
                            Continue Shopping
                        </Button>

                    </div>
                </div>
            </div>}
            {isOpen ? <CheckoutModal token={props.token} onRequestClose={onRequestClose}
                cartCount={props.cartCount} setCartCount={props.setCartCount} /> : null}
        </div>
    );
};

export default Cart;
